import React, { Component } from 'react';
import {
    Switch,
    Route,
    Redirect
} from 'react-router-dom';
import Login from './login';
import Signup from './signup';
import Welcome from './welcome';
import Forgotpassword from './forgotpassword';
import Forgotpwdverify from './forgotpwdverify';
import Changepwdconfirm from './changepwdconfirm';
import Changepwd from './changepwd';
import Dashboard from './dashboard';
import Datacorrect from './datacorrect';
import Request from './request';
import { Auth } from 'aws-amplify';

class Routes extends Component {
    // Routes take care of relationships between websites
    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: false,
            isLoading: true
        };
    }

    // set authentication status
    setAuthStatus(authenticated) {
        this.setState({ isAuthenticated: authenticated });
    }

    async componentDidMount() {
        try {
            await Auth.currentSession();
            // set it is authenticated
            this.setAuthStatus(true);
        } catch (e) {
            // console.error(e);
        }
        // it is loaded
        this.setState({ isLoading: false })
    }

    render() {
        const authProps = {
            isAuthenticated: this.state.isAuthenticated,
            // bind to current class
            setAuthStatus: this.setAuthStatus.bind(this)
        };

        return (
            // it is loaded
            !this.state.isLoading &&
            <Switch>
                <Route exact path='/'>
                    <Login auth={authProps} />
                </Route>
                <Route exact path='/signup'>
                    <Signup />
                </Route>
                <Route exact path='/welcome'>
                    <Welcome />
                </Route>
                <Route exact path='/forgotpassword'>
                    <Forgotpassword />
                </Route>
                <Route exact path='/forgotpwdverify'>
                    <Forgotpwdverify />
                </Route>
                <Route exact path='/changepwdconfirm'>
                    <Changepwdconfirm />
                </Route>
                {/* if user is authenticated, launch the page, otherwise go back to login page */}
                <Route exact path='/changepwd'>
                    {this.state.isAuthenticated ? <Changepwd /> : <Redirect to={'/'} />}
                </Route>
                <Route exact path='/dashboard'>
                    {this.state.isAuthenticated ? <Dashboard /> : <Redirect to={'/'} />}
                </Route>
                <Route exact path='/datacorrect'>
                    {this.state.isAuthenticated ? <Datacorrect /> : <Redirect to={'/'} />}
                </Route>
                <Route exact path='/request'>
                    {this.state.isAuthenticated ? <Request /> : <Redirect to={'/'} />}
                </Route>

                <Redirect to={'/'} />


            </Switch>
        )
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/routes/routes.js